// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__yzUOX","footerContact":"Footer_footerContact__sOg3a"};